export default "__VITE_ASSET__CcVVhn24__"